const NOTIFICATION_TYPES = [ 'success', 'error', 'warning', 'info' ];

const DEFAULT_DURATIONS = {
	success: 5000,
	error: 8000,
	warning: 7000,
	info: 5000,
};

class KazaNotifications {
	constructor() {
		this.container = null;
		this.activeToast = null;
		this.timer = null;
		this.config = (
			typeof kaza_ajax !== 'undefined' &&
			kaza_ajax.notifications &&
			typeof kaza_ajax.notifications === 'object'
		) ? kaza_ajax.notifications : {};

		this.init();
		this.bindAddToCart();
		this.bindKazaNotify();
	}

	init() {
		if ( this.container ) {
			return;
		}

		this.container = document.createElement( 'div' );
		this.container.className = 'kaza-notifications';
		this.container.setAttribute( 'aria-live', 'polite' );
		this.container.setAttribute( 'aria-relevant', 'additions' );
		document.body.appendChild( this.container );

		window.KazaNotifications = this;
	}

	formatTemplate( template, data ) {
		if ( ! template ) {
			return '';
		}

		return template.replace( /\{(\w+)\}/g, ( match, key ) => {
			if ( data[ key ] == null ) {
				return '';
			}

			return String( data[ key ] );
		} );
	}

	parseCartCountFromFragments( fragments ) {
		if ( ! fragments || typeof fragments !== 'object' ) {
			return '';
		}

		const fragmentHtml = fragments['.items-count.count-in-minicart'];
		if ( ! fragmentHtml || typeof fragmentHtml !== 'string' ) {
			return '';
		}

		const doc = new DOMParser().parseFromString( fragmentHtml, 'text/html' );
		const text = doc.body ? doc.body.textContent : '';
		const count = parseInt( text, 10 );

		return Number.isNaN( count ) ? '' : count;
	}

	getProductNameFromDom( $button ) {
		if ( $button && $button.length ) {
			const $product = $button.closest( '.product, .product-small, li.product, .shop-the-look-page__product' );
			if ( $product.length ) {
				const name = $product.find( '.woocommerce-loop-product__title, .product-title, .product__title-text, .shop-the-look-page__product-title, h2, h3' ).first().text();
				if ( name ) {
					return name.trim();
				}
			}
		}

		if ( document.body.classList.contains( 'single-product' ) ) {
			const titleEl = document.querySelector( '.product__title-text' );
			if ( titleEl && titleEl.textContent ) {
				return titleEl.textContent.trim();
			}
		}

		return '';
	}

	getCartCount() {
		const badge = document.querySelector( '.count-in-minicart' );
		if ( ! badge || ! badge.textContent ) {
			return '';
		}

		const count = parseInt( badge.textContent, 10 );
		return Number.isNaN( count ) ? '' : count;
	}

	resolveCartCount( fragments, quantity ) {
		const fromFragments = this.parseCartCountFromFragments( fragments );
		if ( fromFragments !== '' ) {
			return fromFragments;
		}

		const fromDom = this.getCartCount();
		if ( fromDom !== '' ) {
			return fromDom;
		}

		return quantity;
	}

	showAddToCartNotification( options = {} ) {
		if ( ! this.config.addToCartEnabled ) {
			return;
		}

		const quantity = options.quantity != null ? options.quantity : 1;
		const data = {
			product_name: options.product_name || '',
			quantity,
			cart_count: options.cart_count != null
				? options.cart_count
				: this.resolveCartCount( options.fragments, quantity ),
		};

		const message = options.message || this.formatTemplate( this.config.template, data );
		if ( ! message ) {
			return;
		}

		this.show( {
			message,
			type: 'success',
			duration: this.config.duration != null ? this.config.duration : DEFAULT_DURATIONS.success,
		} );
	}

	show( options = {} ) {
		const {
			message,
			type = 'success',
			duration,
			dismissible = true,
		} = options;

		if ( ! message || ! this.container ) {
			return;
		}

		let notificationType = type;
		if ( ! NOTIFICATION_TYPES.includes( notificationType ) ) {
			notificationType = 'success';
		}

		const autoDuration = duration != null ? duration : ( DEFAULT_DURATIONS[ notificationType ] || DEFAULT_DURATIONS.success );

		if ( notificationType === 'error' || this.activeToast ) {
			this.dismissActive();
		}

		const toast = document.createElement( 'div' );
		toast.className = `kaza-notification kaza-notification--${ notificationType }`;
		toast.setAttribute(
			'role',
			notificationType === 'error' ? 'alert' : 'status'
		);

		const messageEl = document.createElement( 'div' );
		messageEl.className = 'kaza-notification__message';
		messageEl.textContent = message;
		toast.appendChild( messageEl );

		if ( dismissible ) {
			const closeBtn = document.createElement( 'button' );
			closeBtn.type = 'button';
			closeBtn.className = 'kaza-notification__close';
			closeBtn.setAttribute( 'aria-label', this.config.closeLabel || 'סגור' );
			closeBtn.textContent = '\u00D7';
			closeBtn.addEventListener( 'click', () => {
				this.dismissToast( toast );
			} );
			toast.appendChild( closeBtn );
		}

		this.container.appendChild( toast );
		this.activeToast = toast;

		requestAnimationFrame( () => {
			toast.classList.add( 'kaza-notification--visible' );
		} );

		if ( autoDuration > 0 ) {
			this.timer = window.setTimeout( () => {
				this.dismissToast( toast );
			}, autoDuration );
		}
	}

	dismissActive() {
		if ( this.activeToast ) {
			this.dismissToast( this.activeToast );
		}
	}

	dismissToast( toast ) {
		if ( ! toast || ! toast.parentNode ) {
			return;
		}

		window.clearTimeout( this.timer );
		this.timer = null;

		toast.classList.remove( 'kaza-notification--visible' );
		toast.classList.add( 'kaza-notification--dismissing' );

		const removeToast = () => {
			if ( toast.parentNode ) {
				toast.parentNode.removeChild( toast );
			}

			if ( this.activeToast === toast ) {
				this.activeToast = null;
			}
		};

		const prefersReducedMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;
		if ( prefersReducedMotion ) {
			removeToast();
			return;
		}

		toast.addEventListener( 'transitionend', removeToast, { once: true } );
		window.setTimeout( removeToast, 300 );
	}

	bindAddToCart() {
		const self = this;

		jQuery( document.body ).on( 'added_to_cart', function( event, fragments, cartHash, $button ) {
			if ( ! self.config.addToCartEnabled ) {
				return;
			}

			if ( $button && $button.data( 'kaza-notified' ) ) {
				return;
			}

			if ( $button ) {
				$button.data( 'kaza-notified', true );
				window.setTimeout( () => {
					$button.removeData( 'kaza-notified' );
				}, 200 );
			}

			const $form = $button ? $button.closest( 'form.cart' ) : jQuery();
			let quantity = 1;
			const $qtyInput = $form.find( 'input[name="quantity"]' );

			if ( $qtyInput.length ) {
				quantity = parseInt( $qtyInput.val(), 10 ) || 1;
			}

			self.showAddToCartNotification( {
				product_name: self.getProductNameFromDom( $button ),
				quantity,
				fragments,
			} );
		} );
	}

	bindKazaNotify() {
		const self = this;

		jQuery( document.body ).on( 'kaza:notify', function( event, options ) {
			if ( options && typeof options === 'object' ) {
				self.show( options );
			}
		} );
	}
}

export default new KazaNotifications();
